type Typography = {
  header: { [key: string]: string };
  paragraph: { [key: string]: string };
};

const TYPOGRAPHY: Typography = {
  header: {
    xl: 'text-h-1 lg:text-hd-1', // Header 01
    lg: 'text-h-2 lg:text-hd-2', // Header 02
    base: 'text-h-3 lg:text-hd-3', // Header 03
    sm: 'text-h-4 lg:text-hd-4', // Header 04
    xs: 'text-hd-5', // Header 05
  },
  paragraph: {
    xl: 'text-body-xl', // Body Large
    lg: 'text-body-lg', // Body Medium
    base: 'text-body-base ', // Body Small
    sm: 'text-body-sm', // Caption
    xs: 'text-body-xs', // Metadata
  },
};

export default TYPOGRAPHY;
